import { createSlice } from "@reduxjs/toolkit";

export const sessionSlice = createSlice({
  name: "auth/session",
  initialState: {
    token: "",
    refresh: "",
    signedIn: false,
  },
  reducers: {
    onSignInSuccess: (state, action) => {
      state.signedIn = true;
      state.token = action.payload.token;
      state.refresh = action.payload.refresh;
    },
    onSignOutSuccess: (state) => {
      state.signedIn = false;
      state.token = "";
      state.refresh = "";
    },
    setToken: (state, action) => {
      state.token = action.payload.token;
      state.refresh = action.payload.refresh;
    },
  },
});

export const { onSignInSuccess, onSignOutSuccess, setToken } = sessionSlice.actions;

export default sessionSlice.reducer;
